import { useContext, useEffect, useMemo, useState } from "react"
import { callautopopulate } from "../../../services/callautopop"
import _ from "underscore"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { ToastContext } from "../../../context/ToastContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const useUserMappingWithBranch = () => {

    const { showSuccess, showInfo, showError } = useContext(ToastContext);
    const [options, setoptions] = useState({});
    const [formValues, setFormValues] = useState({});
    const [loader, setLoader] = useState(false);
    const [rowData,setRowData] = useState([])
    const [confirmationPopup, setConfirmationPopup] = useState({
        show: false,
        id: ""
    });
    const columnDefs = [
        {
            headerName: "User Name",
            field: "user_display_name",
            minWidth: 180,
            width: "30%",
        },
        {
            headerName: "Branch Name",
            field: "group_name",
            minWidth: 180,
            width: "30%",
        },
        {
            headerName: "Action",
            field: "",
            minWidth: 80,
            width: "20%",
            cellStyle: { textAlign: "center" },
            cellRenderer: (params) => {
                return (
                    <FontAwesomeIcon
                        icon="fa-solid fa-trash"
                        className="remove"
                        onClick={() => setConfirmationPopup({ show: true, id: params?.data?.permission_id })}
                    />
                )
            }
        },
    ]

    useEffect(() => {
        callautopopulate("all_users", "day_calendar_groups").then((res) => {
            setoptions({ allUser: _.sortBy(res?.all_users, "user_display_name"), groups: res?.day_calendar_groups })

        }).catch((error) => {
            console.error("error", error)
        })
    }, []);


    useEffect(() => {
        getUserMappingData()
    }, [])

    const getUserMappingData = async () => {
        try {
            setLoader(true)
            const res = await services.getInvokeRemote("GET", Urls("GETUSERUNITPERMISSION"));
            if (!res?.body?.error_status) {
                setLoader(false)
                setRowData(res?.body?.data?.user_permision_list)
            }
        } catch (error) {
            setLoader(false)
            console.error("error::", error)
            showError('Error', error.response.data.errorMessage);
        }
    }

    const upsertMapping = async () => {
        try {
            if (!formValues?.users) {
                showInfo("Info", "Please select user.");
                return
            }
            if (!formValues?.group_id) {
                showInfo("Info", "Please select a Unit.");
                return
            }
            const payload = {
                "requested_users": _.pluck(formValues?.users, "user_code").toString(),
                "group_id": formValues?.group_id?.group_id
            }
            const res = await services.getInvokeRemote("POST", Urls("SAVEUSERUNITPERMISSION"), payload)
            if (res?.body?.StatusCode === 400 || res?.body?.StatusCode === 204 || res?.body?.StatusCode === 202 || res?.body?.StatusCode === 401 || res?.body?.StatusCode === 500) {
                showError("error", res?.body?.errorMessage);
                return;
            } else if (res?.body?.error_status) {
                showError("error", res?.body?.message);
            } else {
                setFormValues({});
                getUserMappingData();
                showSuccess("success", res.body.message);
            }
        } catch (error) {
            console.error("error", error)
        }
    }

    const HandleDeleteMapping = async () => {
        try {
            const payload = {
                "permission_id": confirmationPopup?.id
            }
            const res = await services.getInvokeRemote("POST", Urls("DELETEUSERUNITPERMISSION"), payload)
            if (!res?.body?.error_status) {
                showSuccess("success", res?.body?.message);
                setConfirmationPopup({ show: false, id: "" })
                getUserMappingData()
            } else {
                showError("error", res.body.errorMessage)
            }
        } catch (error) {
            console.error("error::", error)
            showError('Error', error.response.data.errorMessage);
        }
    }

    return useMemo(() => ({
        options, formValues, setFormValues, upsertMapping, confirmationPopup, setConfirmationPopup, HandleDeleteMapping, loader,columnDefs,rowData
    }), [options, formValues, setFormValues, upsertMapping, confirmationPopup, setConfirmationPopup, HandleDeleteMapping, loader,columnDefs,rowData])
}